import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIChevronUpCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "20 20 480 480",
	width: "1em",
	height: "1em",
	className: "g-icon",
	...props,
	children: [/* @__PURE__ */ _jsx("polyline", {
		points: "352 296 256 200 160 296",
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 32
		}
	}), /* @__PURE__ */ _jsx("path", {
		d: "M256,64C150,64,64,150,64,256s86,192,192,192,192-86,192-192S362,64,256,64Z",
		style: {
			fill: "none",
			stroke: "currentColor",
			strokeMiterlimit: 10,
			strokeWidth: 32
		}
	})]
});
export default SvgIChevronUpCircle;
